import { useEffect } from "react";

/**
 * Analytics loader — only activates when the corresponding env vars are set.
 *
 * Available env vars (add to /app/frontend/.env then redeploy):
 *   REACT_APP_GA_MEASUREMENT_ID   -> Google Analytics 4 (e.g. "G-XXXXXXXXXX")
 *   REACT_APP_GSC_VERIFICATION    -> Google Search Console verification token (the content="..." value from the meta tag GSC gives you)
 *   REACT_APP_META_PIXEL_ID       -> Meta (Facebook) Pixel ID (numeric)
 *
 * No env var set = nothing loads. Safe to ship as-is.
 */
export default function Analytics() {
    const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
    const GSC = process.env.REACT_APP_GSC_VERIFICATION;
    const META_PIXEL = process.env.REACT_APP_META_PIXEL_ID;

    useEffect(() => {
        // Google Search Console verification meta tag
        if (GSC && !document.querySelector('meta[name="google-site-verification"]')) {
            const m = document.createElement("meta");
            m.name = "google-site-verification";
            m.content = GSC;
            document.head.appendChild(m);
        }

        // Google Analytics 4
        if (GA_ID && !window.__gaLoaded) {
            const s1 = document.createElement("script");
            s1.async = true;
            s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
            document.head.appendChild(s1);

            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            window.gtag = gtag;
            gtag("js", new Date());
            gtag("config", GA_ID, { anonymize_ip: true });
            window.__gaLoaded = true;
        }

        // Meta Pixel
        if (META_PIXEL && !window.__fbqLoaded) {
            /* eslint-disable */
            !(function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod
                        ? n.callMethod.apply(n, arguments)
                        : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = "2.0";
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(
                window,
                document,
                "script",
                "https://connect.facebook.net/en_US/fbevents.js",
            );
            window.fbq("init", META_PIXEL);
            window.fbq("track", "PageView");
            window.__fbqLoaded = true;
            /* eslint-enable */
        }
    }, [GA_ID, GSC, META_PIXEL]);

    return null;
}
